module.exports = new __parcel__URL__("the-beatles-1962-1966.572ddb19.jpg").toString();